<template>
  <div>
    <header-bar>レポート</header-bar>
    <div
      id="revenue-report-section"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">報告書ダウンロード</h3>
        <a
          v-if="showCopyrightReport() && filteredCopyrightReports.length"
          href="#"
          @click.prevent="scrollToCopyright">著作権使用料支払報告書へ</a>
      </div>
      <div class="page-block__inner">
        <div class="report-block download">
          <div class="report-finalized-download-area">
            <table class="report-finalized-download-area__table">
              <thead class="report-finalized-download-area__thead">
                <tr>
                  <th>期</th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="report-finalized-download-area__tbody">
                <tr v-if="!reports.length">
                  <td
                    class="no-data"
                    colspan="2">
                    レポートはありません。
                  </td>
                </tr>                <tr
                  v-for="report in reports"
                  :key="report.title">
                  <td>{{ report.title }}</td>
                  <td>
                    <finalized-report-download-buttons
                      :payment_id="report.payment_id"
                      :reports="report.finalized_reports" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showCopyrightReport() && filteredCopyrightReports.length"
      id="copyright-report-section"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">著作権報告書ダウンロード</h3>
        <a
          href="#"
          @click.prevent="scrollToRevenue">分配報告書へ</a>
      </div>
      <div class="page-block__inner">
        <div class="report-block download">
          <div class="report-finalized-download-area">
            <table class="report-finalized-download-area__table">
              <thead class="report-finalized-download-area__thead">
                <tr>
                  <th>期</th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="report-finalized-download-area__tbody">
                <tr v-if="!filteredCopyrightReports.length">
                  <td
                    class="no-data"
                    colspan="2">
                    レポートはありません。
                  </td>
                </tr>
                <tr
                  v-for="report in filteredCopyrightReports"
                  :key="report.title">
                  <td>{{ report.title }}</td>
                  <td>
                    <finalized-report-download-buttons
                      :is-copyright-report="true"
                      :payment_id="0"
                      :reports="report.copyright_reports" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import HeaderBar from '../HeaderBar'
import FinalizedReportDownloadButtons from './FinalizedReportDownloadButtons'

export default {
  components: {
    HeaderBar,
    FinalizedReportDownloadButtons,
  },
  computed: {
    filteredCopyrightReports() {
      if (this.permission === 9) {
        return this.copyrightReports.filter(
          (report) => report.copyright_reports
            && report.copyright_reports.length > 0,
        )
      }
      return this.copyrightReports.filter(
        (report) => report.copyright_reports
          && report.copyright_reports.length > 0
          && report.copyright_reports[0].is_fixed === 1,
      )
    },
  },
  data() {
    return {
      reports: [],
      copyrightReports: [],
      permission: null,
    }
  },
  mounted() {
    this.fetchFinalizeList()
    this.fetchCopyrightFiles()
    this.fetchCompanies()
  },
  methods: {
    async fetchFinalizeList() {
      const { data } = await window.axios.get('/api/client/reports/finalized/file-list', {
        params: {
          latest: false,
        },
      })
      this.reports = data.filter(report => 'finalized_reports' in report && report.finalized_reports.length)
    },
    async fetchCopyrightFiles() {
      const { data } = await window.axios.get('/api/client/copyrights/finalized/file-list', {
        params: {
          latest: false,
        },
      })
      this.copyrightReports = data
    },
    async fetchCompanies() {
      const { data } = await window.axios.get(`/api/client/users/${this.$store.state.auth.id}`)
      this.permission = data.permission
    },
    showCopyrightReport() {
      if (this.isBtoC) {
        return true
      }
      if (this.permission === 9) {
        return true
      }
      // 2025/5/30 0:00:00 以降は true
      return moment()
        .isAfter('2025-05-30 00:00:00')
    },
    scrollToRevenue() {
      const el = document.getElementById('revenue-report-section')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    scrollToCopyright() {
      const el = document.getElementById('copyright-report-section')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
  },
}
</script>
